import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { SENTRY_ENABLED, SENTRY_DSN, environment } from "./config/envConfig";

if (SENTRY_ENABLED) {
  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    environment: environment,
  });
}

window.addEventListener("error", (event) => {
  const message = event?.message || "";

  if (message.includes("Loading chunk") || message.includes("ChunkLoadError")) {
    console.warn("Chunk load failed — reloading page...");
    window.location.reload(true);
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason?.message || "";
  if (reason.includes("Loading chunk") || reason.includes("ChunkLoadError")) {
    console.warn("Chunk load failed — reloading page...");
    window.location.reload(true);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
